module.exports = __webpack_public_path__ + "img/storeThr.c0a6fa67.jpg";